/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorEditConversationsEditNewScorecardAttributeRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.edit.conversations.edit.new-scorecard.attribute',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(
  AutomationFinAiAgentAnalyzeMonitorEditConversationsEditNewScorecardAttributeRoute,
);
